import React from 'react';
import './Tagline.css';

function Tagline(props) {
	return (
		<div className="c-tagline u-doubleBaseInnerSpacing u-doubleBaseInnerSpacing--responsive">
			<div className="c-tagline__text">
				{props.text}
			</div>
		</div>
	)
}

export default Tagline;


// WEBPACK FOOTER //
// ./src/components/Tagline.js